import PropTypes from 'prop-types';
import ItemView from '../../components/ItemView';
import getImage from 'helpers/getImage';

export default function SpecialOrderView({
  ingredientCategories,
  orderItem,
  closeOrder,
  itemInProgress,
  openedItemId,
  addToOrder,
  rightSideViewVisibilityIndex,
  toggleAnimation,
  sidebarAnimationClass,
}) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
      }}
      className={sidebarAnimationClass}
    >
      <ItemView
        key={String(toggleAnimation)}
        ingredientCategories={ingredientCategories}
        orderItem={orderItem}
        name={orderItem && orderItem.name ? orderItem.name : ''}
        imageUrl={getImage(orderItem?.mediaPath || orderItem?.urlS3)}
        description={
          orderItem && orderItem.description ? orderItem.description : ''
        }
        closeItem={closeOrder}
        itemInProgress={itemInProgress}
        openedItemId={openedItemId}
        addToOrder={addToOrder}
        rightSideViewVisibilityIndex={rightSideViewVisibilityIndex}
        openedFrom={'special'}
      />
    </div>
  );
}

SpecialOrderView.propTypes = {
  rightSideViewVisibilityIndex: PropTypes.any,
  sizeID: PropTypes.any,
  sizeName: PropTypes.any,
};
